import { ImageUpload } from '@/components/ui/ImageUpload/ImageUpload'
import type {
  PropertyFormInput,
  PropertyFormOutput,
} from '@/schemas/propertySchema'
import { VStack } from '@chakra-ui/react'
import { Control, useController } from 'react-hook-form'

interface ImagesStepProps {
  control: Control<PropertyFormInput<boolean>, any, PropertyFormOutput<boolean>>
}

export function ImagesStep({ control }: ImagesStepProps) {
  const {
    field: { value: images = [], onChange: onImagesChange },
  } = useController({
    name: 'images',
    control,
  })

  return (
    <VStack spacing={6} align="stretch">
      <ImageUpload
        images={images}
        onImagesChange={onImagesChange}
        maxImages={10}
        maxSizePerImage={5}
      />
    </VStack>
  )
}
